import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtCmb from "../Components/CustomTool/CtCmb";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchServiceLocation } from "./API";

class ServiceLocation extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        size: 10,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_brname",
        header: "Branch Name",
        size: 200,
      },
      {
        accessorKey: "vac_servicelocation",
        header: "Service Location",
        size: 300,
      },
    ],

    rows: [
      {
        bint_srno: 1,
        vac_brname: "Branch 1",
        vac_servicelocation: "Location 1",
      },
    ],
    branchList: [],
    formData: {
      bint_srno: 0,
      cmbBranchName: "",
      txtServiceLocation: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Service Location");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveServiceLocation,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtServiceLocation,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_brname",
      "vac_servicelocation",
    ]);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno: row.bint_srno,
        cmbBranchName: row.vac_brname,
        txtServiceLocation: row.vac_servicelocation,
      },
    });
    document.getElementById("cmbBranchName").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_servicelocation"]);
    this.DeleteData(row.bint_srno, row.vac_servicelocation);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListServiceLocation",
    };
    fetchServiceLocation(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        const rows = res.data.ServiceLocationList || [];
        const rowsCount = rows.length;
        const branchList = res.data.BranchName;

        this.setState({
          rows,
          rowsCount,
          branchList,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("cmbBranchName").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          cmbBranchName: "",
          txtServiceLocation: "",
        },
      },
      () => {
        document.getElementById("cmbBranchName").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationServiceLocation = () => {
    let result = false;
    if (this.state.formData.cmbBranchName.length <= 0) {
      this.props.toastErrorMsg("Select Branch Name", "cmbBranchName");
    } else if (this.state.formData.txtServiceLocation.length <= 0) {
      this.props.toastErrorMsg("Enter Service Location", "txtServiceLocation");
    } else {
      result = true;
    }
    return result;
  };

  saveServiceLocation = () => {
    this.trimFormData(() => {
      if (this.validationServiceLocation()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveServiceLocation",
          bint_srno: this.state.formData.bint_srno,
          vac_brname: this.state.formData.cmbBranchName,
          vac_servicelocation: this.state.formData.txtServiceLocation,
        };
        fetchServiceLocation(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (
                res.data.ServiceLocationList &&
                res.data.ServiceLocationList.length > 0
              ) {
                rows = res.data.ServiceLocationList;
                rowsCount = rows.length;
              }
              const branchList =
                res.data.BranchList ||
                res.data.Branch ||
                res.data.Branches ||
                this.state.branchList;
              this.setState(
                {
                  rows,
                  rowsCount,
                  branchList,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in Save Service Location.",
              error,
            );
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_servicelocation) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_servicelocation} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteServiceLocation(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteServiceLocation = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteServiceLocation",
      bint_srno: bint_srno,
    };
    fetchServiceLocation(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (
            res.data.ServiceLocationList &&
            res.data.ServiceLocationList.length > 0
          ) {
            rows = res.data.ServiceLocationList;
            rowsCount = rows.length;
          }
          const branchList =
            res.data.BranchList ||
            res.data.Branch ||
            res.data.Branches ||
            this.state.branchList;
          this.setState(
            {
              rows,
              rowsCount,
              branchList,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Service Location. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveServiceLocation}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtServiceLocation,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbBranchName"
              label="Branch Name*"
              items={this.state.branchList}
              value={this.state.formData.cmbBranchName}
              handleOnChange={this.handleOnChange}
              width={240}
              colID="vac_brname"
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtServiceLocation"}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtServiceLocation"
              label="Service Location*"
              value={this.state.formData.txtServiceLocation}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.saveServiceLocation}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Service Location")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={40}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <ServiceLocation {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
